// src/pages/settings/forms/builderDrawer/elements/DraggableElement.tsx
import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { FormElement } from "../../../../../../api/formApi";

interface DraggableElementProps {
	element: Omit<FormElement, "id">;
	draggableId: string;
}

export const DraggableElement: React.FC<DraggableElementProps> = ({ element, draggableId }) => {
	const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
		id: draggableId,
		data: {
			from: "toolbox",
			type: element.type,
			label: element.label,
			options: element.options || [],
		},
	});

	const style: React.CSSProperties = {
		transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
		opacity: isDragging ? 0.5 : 1,
		cursor: "grab",
		padding: "8px 10px",
		border: `1px solid var(--mg-border)`,
		borderRadius: 6,
		background: "var(--mg-bg-elevated)",
		fontSize: 12,
		color: "var(--mg-text)",
		transition: "all 0.15s",
		userSelect: "none",
		touchAction: "none",
	};

	const hoverStyle: React.CSSProperties = {
		borderColor: "var(--mg-primary-border)",
		background: "var(--mg-primary-bg)",
		color: "var(--mg-primary)",
	};

	const [isHovered, setIsHovered] = React.useState(false);

	return (
		<div ref={setNodeRef} style={{ ...style, ...(isHovered && !isDragging ? hoverStyle : {}) }} {...listeners} {...attributes} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
			{element.label}
		</div>
	);
};
